import { IA_KEY } from 'helpers/ia-logic';

import Items from './ItemsContainer';
import { watchActions } from './Items.saga';

export default [
  {
    path: '/items/:venueId?',
    component: Items,
    iaKey: IA_KEY.ITEMS_ROUTE,
    pathSagas: [watchActions],
  },
];
